import { createFileRoute } from "@tanstack/react-router";

import { OnboardingLayout } from "@/components/routes/OnboardingLayout";

export const Route = createFileRoute("/app/companies/$company_id/onboarding")({
  component: OnboardingLayout,
});
